export default __webpack_public_path__ + "static/media/758.bd0841fd.png";